import React, { useState, useContext } from 'react'
import Product from './product'
//import { MapContext } from "./map-context";

class ProductList extends React.Component {


	constructor(props) {
		super(props);
	}

	renderProducts = ( type ) => {

		const mobileArray = []
		const nonMobileArray = []


		this.props.products.map((value, index) => {
			if( Number(value.lat) != 0 && Number(value.lon) != 0 ) {
				nonMobileArray.push({
					product: value,
					id: value.id,
					name: value.name
				})
			} else if( Number(value.lat) == 0 && Number(value.lon) == 0 ) {
				mobileArray.push({
					product: value,
					id: value.id,
					name: value.name,
					mobile: 'mobile'
				})
			}
		})

		const newArray = [...nonMobileArray, ...mobileArray];

		switch( type ) {
			case 'promoted':
				return (
					this.props.promoted.map( product => <Product promoted={this.props.promoted} product={product} key={product.id} cdnPath={this.props.cdnPath} highlightItem={this.props.highlightItem} highlighted={this.props.highlighted} path={this.props.path} view={this.props.view}  showMap={this.props.showMap}/> )
				)
				break;
			case 'virtual':
				return (
					this.props.virtual.map( product => <Product product={product} key={product.id} cdnPath={this.props.cdnPath} highlightItem={this.props.highlightItem} highlighted={this.props.highlighted} view={this.props.view} path={this.props.path} showMap={this.props.showMap}/> )
				)
				break;
			default:
				if( this.props.loadMore ) {
					return (
						this.props.products.slice(0, this.props.visible).map( product => <Product product={product} key={product.id} cdnPath={this.props.cdnPath} highlightItem={this.props.highlightItem} highlighted={this.props.highlighted} path={this.props.path} view={this.props.view}  showMap={this.props.showMap}/> )
					)
				} else {
					if( this.props.showMap && this.props.view == 'map' ) {
						return (
							newArray.map( value => <Product product={value.product} key={value.id} cdnPath={this.props.cdnPath} highlightItem={this.props.highlightItem} highlighted={this.props.highlighted} view={this.props.view} path={this.props.path} showMap={this.props.showMap} mobile={value.mobile}/>
						)
					)
					} else {
						return (
							this.props.products.map( product => <Product product={product} key={product.id} cdnPath={this.props.cdnPath} highlightItem={this.props.highlightItem} highlighted={this.props.highlighted} path={this.props.path} view={this.props.view} showMap={this.props.showMap} />
					)
				)
			}
		}
	}
}

	render () {

		const promotedCols = this.props.promoted.length == 3 ? 3 : 4;
		//const [currentProduct, seCurrentProduct] = useContext(MapContext);

		return (

			<div>


				<div className="grid-x grid-padding-x">
					<div className="small-12 cell"><h4>{this.props.products.length} activities found in {this.props.config.tag} {this.props.location}</h4></div>
				</div>

				{this.props.virtual.length > 0 ? (
					<div className="product-grid__promoted--row">
						<h4>Virtual Experiences</h4>
						<p>Virtual experiences have the power to connect you with your friends, colleagues or family; removing location as a limitation. These fantastic experiences have been specifically designed to have you laughing, learning and bonding, all from the comfort of your own home.</p>
						<div className={`grid-x grid-padding-x small-up-1 medium-up-2 large-up-${promotedCols} product-grid ${ this.props.view }-view`}>
								{this.renderProducts( 'virtual' )}
						</div>
					</div>
				) : null }


				{this.props.promoted.length > 0 ? (
					<div className="product-grid__promoted--row">
						<div className={`grid-x grid-padding-x small-up-1 medium-up-2 large-up-${promotedCols} product-grid ${ this.props.view }-view`}>
								{this.renderProducts( 'promoted' )}
						</div>
					</div>
				) : null }

				<div className={this.props.view == 'map' ? `grid-x grid-padding-x small-up-1 medium-up-2 large-up-3 xlarge-up-4 product-grid ${ this.props.view }-view` : `grid-x grid-padding-x small-up-1 medium-up-2 large-up-3 xlarge-up-4 product-grid ${ this.props.view }-view` }>
					{this.renderProducts( false, false )}
				</div>


				{ this.props.loadMore && this.props.visible < this.props.products.length &&
					<div className="grid-x grid-padding-x align-center">
						<div className="cell medium-6 text-center">
							<button onClick={this.props.handleLoadMore} type="button" className="load-more">Load more</button>
						</div>
					</div>
				}

			</div>
		)
	}
};




export default ProductList
